export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-secondary-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-film-line text-lg text-white"></i>
              </span>
              <span className="font-heading text-xl font-bold text-white">陌陌影视</span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-300 mb-4">
              陌陌影视💡电影大全，提供最新电影、热映大片、经典老片和电影排行榜。
              高清画质免费在线观看，资源丰富每日更新，极速播放不卡顿。
              致力于为每一位影迷打造最舒适便捷的在线观影体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-500 text-secondary-300 hover:text-white cursor-pointer transition-all duration-200">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-500 text-secondary-300 hover:text-white cursor-pointer transition-all duration-200">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-500 text-secondary-300 hover:text-white cursor-pointer transition-all duration-200">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '精彩预告', href: '#media' },
                { label: '焦点专题', href: '#carousel' },
                { label: '热播榜单', href: '#ranking' },
                { label: '影视专题', href: '#index' },
                { label: '精选推荐', href: '#cards' },
              ].map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-secondary-300 hover:text-accent-400 cursor-pointer transition-colors duration-200">{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">服务支持</h4>
            <ul className="space-y-2.5">
              {[
                { label: '关于陌陌', href: '#about' },
                { label: '最新动态', href: '#updates' },
                { label: '投稿联系', href: '#contact' },
                { label: '常见问答', href: '#faq' },
                { label: '平台特色', href: '#features' },
              ].map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-secondary-300 hover:text-accent-400 cursor-pointer transition-colors duration-200">{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-secondary-400 leading-relaxed">
              感谢各大影视内容合作方对陌陌影视的支持。我们持续拓展优质内容渠道，
              为观众带来更多精彩的电影资源。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 陌陌影视 mमो.movies — 本站内容仅供学习交流，请于下载后24小时内删除
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-400">
            <a href="#" className="hover:text-accent-400 cursor-pointer transition-colors">用户协议</a>
            <a href="#" className="hover:text-accent-400 cursor-pointer transition-colors">隐私政策</a>
            <a href="#" className="hover:text-accent-400 cursor-pointer transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}